import { render, staticRenderFns } from "./PassageViewer.vue?vue&type=template&id=1d6f433a"
import script from "./PassageViewer.vue?vue&type=script&lang=ts"
export * from "./PassageViewer.vue?vue&type=script&lang=ts"
import style0 from "./PassageViewer.vue?vue&type=style&index=0&id=1d6f433a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports